import { cx } from "@jugl-web/utils";
import { forwardRef, HTMLAttributes, ReactNode } from "react";

interface HeaderBreadcrumbsItemContainerProps
  extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  isLast?: boolean;
  className?: string;
  onClick?: () => void;
}

export const HeaderBreadcrumbsItemContainer = forwardRef<
  HTMLDivElement,
  HeaderBreadcrumbsItemContainerProps
>(({ children, isLast, className, onClick, ...props }, ref) => (
  <div
    ref={ref}
    className={cx(
      "text-dark font-secondary whitespace-nowrap text-lg font-normal leading-5",
      !!onClick && "cursor-pointer",
      isLast && "truncate font-medium",
      className
    )}
    onClick={onClick}
    {...props}
  >
    {children}
  </div>
));
